import React, {useEffect} from 'react';
import styles from './BlogPage.module.css'; // Import module-specific styles
import posts from "../../Data/BlogPosts.json"; // Import blog data
import MainLayout from '../../Layout/MainLayout'
import image1 from '../../Assets/Blog/Image1.png'
import { Link } from 'react-router-dom';

const BlogPage = () => {
    // Scroll to the top of the page when the component mounts 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [])
    return (
        <MainLayout> {/* Wrapper component for main layout structure */}
            <div className={styles.blog}>
                {/* Title & Trending blog post section linked to blog post */}
            <Link to={`/blog/6`} className={styles.blog1}>
                    <h1>Read our latest blogs</h1>
                    <p className="pLarge">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor.</p>
                    <div className={styles.blog1Bottom}>
                        <div className={styles.blog1BLeft}>
                            <h4>Trending Post</h4>
                            <h2>New invoicing features to help you get paid faster</h2>
                            <p>Over the past few months, we’ve added several new features to SaaS Invoicing to help any business get paid faster and streamline their collection workflows.</p>
                            <text>Luke Matthews l  November 8, 2021</text>
                        </div>
                        <img src={image1} alt="Blog"></img>
                    </div>
                </Link>
                {/* Section for all blog posts (linked to their own blog page), not including trending, displayed */}
                <div className={styles.blog2}>
                    <h1>All Posts</h1>
                    <div className ={styles.blogPostContainer}>{
                        posts.filter((_, index) => index !== 6).slice(0, 9).map((post, id) => {
                            return (
                                <Link to={`/blog/${id}`} key={id} className={styles.blogPost}>
                                <img src = {post.image} alt = {post.title}></img>
                                <h4>{post.title}</h4>
                                <p>{post.description}</p>
                                <text>{`${post.author} l ${post.date}`}</text>
                             </Link>
                            )
                         })
                    }</div>
                </div>
            </div>
        </MainLayout>
    )
}

export default BlogPage